var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"grupo-pontuacao-aluno","rota-base":"/admin/grupo-pontuacao-aluno","titulo-singular":"Grupo de Pontuação de Aluno","campos-extras":[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]}})
}
var staticRenderFns = []

export { render, staticRenderFns }